import Service from "../Service";

const resource = "orderpurchasefile/";

export default {
  updateFileStatusPortal(obj, requestID) {
    return Service.post(resource + "approvefileportal", obj, {
      params: { requestID },
    });
  },
};
